import { useDataChange, useDataValue } from 'Simple/Data.js'

export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.apps_filter',
    viewPath: props.viewPath,
  })

  let installAppId = useDataValue({
    context: 'tab',
    path: 'selected.install_app_id',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    let hasGranted = value?.some(item =>
      item.companies.some(
        company =>
          company.status === 'granted' &&
          (!installAppId || item.id === installAppId)
      )
    )

    change(hasGranted ? 'installed' : 'directory')
  }
}
